import { AbstractClient, CompositionClient } from "@/app/client";
import * as types from "@/app/types";
import { UUID } from "crypto";

export default class APIFlowId extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  postValidate = async (flowId: UUID): Promise<types.FlowResponse> => {
    let res = await this._fetch({
      url: `/flows/${flowId}/validate`,
      method: "POST",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
